import { Entity, ctx as L20NContext } from '@sketchpixy/rubix/lib/L20n';
import React from 'react';
import { Field, reduxForm } from 'redux-form';
import CustomField from '../Fields/CustomField.jsx';
import { Divider } from '@material-ui/core';
import SentenceSelectorInputField from '../Fields/SentenceSelectorInputField.jsx';

const validate = values => {
  const errors = {};
  if (!values.codeClub) {
    errors.codeClub = 'required';
  }
  return errors;
};

@reduxForm({ form: 'TenupActivationForm', validate })
class TenupActivationForm extends React.Component {
  
  render() {
    return (
      <div>
        <Entity
          name="codeClub"
          componentClass={Field}
          componentAttribute="placeholder"
          entity=""
          title="Ten'Up Club Id"
          component={CustomField}
        />
        <div style={{ marginTop: 0 }}>
          <Divider />
          <Field
            id="allowAccessMinutesBefore"
            name="allowAccessMinutesBefore"
            component={SentenceSelectorInputField}
            disabled={false}
            containerStyle={{ marginTop: 20, marginLeft: 0 }}
            sentence={L20NContext.getSync('allowAccessMinutesBeforeSentence')}
          />
          <Field
            id="allowAccessMinutesAfter"
            name="allowAccessMinutesAfter"
            component={SentenceSelectorInputField}
            disabled={false}
            containerStyle={{ marginTop: 20, marginLeft: 0 }}
            sentence={L20NContext.getSync('allowAccessMinutesAfterSentence')}
          />
          <Divider style={{marginTop: 20, marginBottom: 10}} />
        </div>
      </div>
    );
  }
} 

export default TenupActivationForm;
